import {useState} from "react";
import {readStorage, writeStorage} from "../utils/storage";

// like useState, the value is stored under `key`, see utils/storage
export function useLocalStorage <T>(key: string, initialValue?: T) {
  const [storedValue, setStoredValue] = useState(() => readStorage<any>(key, initialValue));

  function setValue<S> (value: S) {
    // Allow value to be a function so we have same API as useState
    const valueToStore = value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    writeStorage(key, valueToStore);
  };
  return [storedValue, setValue];
}
